//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import angular, { IRootScopeService } from 'angular';

import { ICollectionSourcesDto } from '@apis/collections/ICollectionSourcesDto';
import { IStream } from '@streams-drawer/model/IStream';
import { IStreamSource } from '@streams-drawer/model/IStreamSource';
import {
  StreamModalType,
  StreamsLaunchContext,
} from '@streams-drawer/streams-drawer-constants';
import { StreamSourceTypes } from '@streams/constants/streamCreationConstants';
import * as streamsConversions from '@streams/models/streamsConversions';
import template from './streams-drawer-header.html';
import './streams-drawer-header.less';

import '@streams/angular/editable-stream-name';
import '@streams/components/StreamSourceLabel';

class StreamsDrawerHeader {
  // Bindings
  public readonly launchContext: StreamsLaunchContext;
  public readonly selectedStream: IStream;
  public readonly shouldNotAllowUgcStreams: boolean;

  public displayedSources: IStreamSource[];
  public extraSources: IStreamSource[];
  public isEditable: boolean;
  public isLoadingSources: boolean;
  public editModalType: StreamModalType;

  public streamsLaunchContext = StreamsLaunchContext;
  public streamSourceTypes = StreamSourceTypes;
  public assetFeedSourceConnectionStates;

  public constructor(private $rootScope: IRootScopeService) {
    this.isEditable = false;
    this.isLoadingSources = false;
  }

  public $onInit() {
    this.$rootScope.$watch(
      () => {
        return this.selectedStream;
      },
      () => {
        this.computeSourcesDisplay();
      },
    );

    this.editModalType =
      this.launchContext === StreamsLaunchContext.ASSET_FEEDS
        ? (this.editModalType = StreamModalType.ASSET_FEEDS)
        : (this.editModalType = StreamModalType.STANDARD);
  }

  private computeSourcesDisplay() {
    this.isLoadingSources = true;

    const streamSources = streamsConversions.convertStreamSourcesToSources(
      this.selectedStream.sources,
      this.selectedStream.sourcesMetadata,
    );

    let currCharCount = 0;
    const displayedSources = [];
    const extraSources = [];

    streamSources.forEach((source) => {
      currCharCount += source.sourceLabel.length;

      // An attempt to smartly truncate while making sure
      // we show at least one source in full
      if (currCharCount < 50 || displayedSources.length === 0) {
        displayedSources.push(source);
      } else {
        extraSources.push(source);
      }
    });

    this.displayedSources = displayedSources;
    this.extraSources = extraSources;

    this.isEditable = !(
      this.launchContext === StreamsLaunchContext.MODERATION_SERVICES ||
      this.isGalleryUploadsStream(this.selectedStream.sources) ||
      this.shouldNotAllowUgcStreams
    );
    this.isLoadingSources = false;
  }

  private isGalleryUploadsStream(
    streamSources: ICollectionSourcesDto,
  ): boolean {
    return (
      streamSources.galleryUploaders &&
      streamSources.galleryUploaders.length > 0
    );
  }

  // Called in streams-drawer-header.html
  private isSourceDisconnected(source: StreamSourceTypes) {
    const isAssetFeedDrawer =
      this.launchContext === StreamsLaunchContext.ASSET_FEEDS;
    const instagramDisconnected =
      (source === StreamSourceTypes.USER || source === StreamSourceTypes.UGC) &&
      !this.assetFeedSourceConnectionStates.instagram;

    return isAssetFeedDrawer && instagramDisconnected;
  }
}

angular.module('curalate').component('streamsDrawerHeader', {
  controller: ['$rootScope', StreamsDrawerHeader],
  bindings: {
    assetFeedSourceConnectionStates: '<',
    brandInstagramUsername: '<',
    launchContext: '<',
    onOpenEditStreamModal: '&',
    onOpenStreamDeleteConfirmationModal: '&',
    selectedStream: '<',
    shouldShowStreamName: '<',
    shouldNotAllowUgcStreams: '<',
  },
  template,
});
